import React, {
  FunctionComponent,
  memo,
  useEffect,
  useMemo,
  useState,
} from 'react';

import styles from './TweetColumnToDownload.module.scss';

import { getTweetColumnData } from 'app/Requests';

import { v4 as uuid } from 'uuid';
import { useQuery, useQueryClient } from 'react-query';
import TwitterTweetCard from 'app/components/TwitterTweetCard';
import InstagramPostCard from 'app/components/InstagramPostCard';
import YouTubeVideoCard from 'app/components/YouTubeVideoCard';
import LinkedinPostCard from 'app/components/LinkedinPostCard';
import TiktokPostCard from 'app/components/TiktokPostCard';
interface Props {
  type: 'negative' | 'positive' | 'neutral' | 'all';
  hideSort?: boolean;
  customFilters?: any;
  requestUrl: string;
  compId: string;
  setTweetsItems?: any;
  endMessage?: string;
  isInfluencerModule?: any;
  setFilterIsLoading?: any;
  filterIsLoading?: boolean;
  isReport?: boolean;
  hideQuestionmarkIcon?: boolean;
  showWrittenAt?: boolean;
  isTemplate?: boolean;
  data?: any;
  reportState?: any;
}

type Response = {
  total_record: number;
  total_page: number;
  records: any[] | null;
};

const TweetColumnToDownload: FunctionComponent<Props> = ({
  type,
  customFilters,
  requestUrl,
  compId,
  setTweetsItems,
  setFilterIsLoading,
  filterIsLoading,
  isReport,
  showWrittenAt,
  data,
}) => {
  const [items, setItems] = useState([]);
  const [filters] = useState(() => ({
    limit: 10,
    ...customFilters,
  }));
  const [page, setPage] = useState(data ? 2 : 1);
  const [isPage, setIsPage] = useState(false);

  const [response, setResponse] = useState<Response>({
    total_record: data ? data?.total_record : 0,
    total_page: data ? data?.total_page : 0,
    records: data ? data?.records : null,
  });

  const queryClient = useQueryClient();

  const { isLoading } = useQuery(
    [
      `getTweetColumnData_${filters?.hashtag_id}`,
      {
        slug: requestUrl,
        category: type,
        body: { ...filters, ...customFilters, page },
      },
    ],
    getTweetColumnData,
    {
      onSuccess: (result) => {
        if (!isPage) {
          setItems(result?.payload?.records);
        } else {
          setItems((old: any) => {
            return [...old, ...result?.payload?.records] as any;
          });
          setIsPage(false);
        }
        setTweetsItems &&
          setTweetsItems((old: any) => {
            return [...old, ...result?.payload?.records];
          });

        if (result?.payload?.records?.length == 0) {
          setResponse({
            records: result.payload?.records,
            total_record: result?.payload?.total_record,
            total_page: result?.payload?.total_page,
          });
        } else {
          setResponse({
            ...response,
            records: result.payload?.records,
            total_record: result?.payload?.total_record,
            total_page: result?.payload?.total_page,
          });
        }
      },

      staleTime: 0,
      refetchOnMount: true,
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnReconnect: true,
    },
  );

  useMemo(() => {
    setPage(1);
    if (!isLoading && filterIsLoading) setFilterIsLoading?.(false);
  }, [customFilters]);
  useEffect(() => {
    return () => {
      queryClient.removeQueries([
        'getTweetColumnData',
        {
          slug: requestUrl,
          category: type,
          body: { ...filters, ...customFilters, page },
        },
      ]);
    };
  }, []);

  const newdataItems = data ? data?.records : items;
  return (
    <div
      className={styles.TweetColumn}
      id={compId}
      data-testid={`column-${type}-holder`}
    >
      {newdataItems?.map(
        (tweet: { icon: any; platform: string; id: string | number }) => {
          return (
            <React.Fragment key={uuid()}>
              <div data-testid={`tweet-box-${uuid()}`} className="mb-10">
                {tweet?.icon === 'Twitter' ? (
                  <TwitterTweetCard
                    compId={tweet?.id ? tweet?.id?.toString() : undefined}
                    isReport={isReport}
                    data={tweet}
                  />
                ) : tweet?.icon === 'Instagram' ? (
                  <InstagramPostCard
                    compId={tweet?.id ? tweet?.id?.toString() : undefined}
                    isReport={isReport}
                    data={tweet}
                  />
                ) : tweet?.icon === 'Youtube' ||
                  tweet?.platform === 'Youtube' ? (
                  <YouTubeVideoCard
                    compId={tweet?.id ? tweet?.id?.toString() : undefined}
                    isReport={isReport}
                    data={tweet}
                  />
                ) : tweet?.icon === 'Linkedin' ? (
                  <LinkedinPostCard
                    compId={tweet?.id ? tweet?.id?.toString() : undefined}
                    isReport={isReport}
                    data={tweet}
                  />
                ) : tweet?.icon === 'Tiktok' ? (
                  <TiktokPostCard
                    compId={tweet?.id?.toString()}
                    isReport={isReport}
                    data={tweet}
                  />
                ) : (
                  <></>
                )}
              </div>
            </React.Fragment>
          );
        },
      )}
    </div>
  );
};

const MemoizedTweetColumn = memo(TweetColumnToDownload);
export default MemoizedTweetColumn;
